import { create } from 'zustand'

interface ModalUnavailableState {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  reset: () => void
}

const initialState = {
  isOpen: false
}

export const useModalUnavailableStore = create<ModalUnavailableState>()(
  (set) => ({
    ...initialState,
    setIsOpen: (isOpen) => set({ isOpen }),
    reset: () =>
      set({
        ...initialState
      })
  })
)
